import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BlankState from '../../../components/BlankState';
import StatusMessages2 from '../../../components/StatusMessages2';

import {
  saveCustomPremiumRates,
  updatePremiumRates
} from '../../../actions/rates';
import { fetchPremiumRates } from '../../../actions/dashboard';

class GoodsRatesForm extends Component {
  constructor(props) {
    super(props);
    const { insurer } = this.props.user.userInfo;

    this.state = {
      insurer,
      filter: {
        insurer
      },

      /* For category custom good rates object table */
      sectionRatesList: [],
      ratesObj: {},

      /* Blanket or Section */
      ratesType: '',

      activeRate: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    const { rates, activeRate = {} } = nextProps;

    /* Clear state holders on saving custom rates */
    if (rates.successSaveCustomRates) {
      this.setState({
        sectionRatesList: [],
        ratesObj: {}
      });
    }

    /* In edit mode, add activeRate to state */
    if (activeRate.hasOwnProperty('id')) {
      const {
        air_excess,
        air_value,
        rail_containerised_value,
        rail_excess,
        rail_non_containerised_value,
        road_containerised_value,
        road_excess,
        road_non_containerised_value,
        sea_containerised_value,
        sea_excess,
        sea_non_containerised_value
      } = activeRate.icc_a;

      this.setState({
        activeRate,
        edit: true,
        ratesObj: {
          air_excess,
          air_value,
          rail_containerised_value,
          rail_excess,
          rail_non_containerised_value,
          road_containerised_value,
          road_excess,
          road_non_containerised_value,
          sea_containerised_value,
          sea_excess,
          sea_non_containerised_value
        }
      });
    } else {
      this.setState({ edit: false });
    }
  }

  setRatesType = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  onChangeRate = e => {
    const { ratesObj } = this.state;
    const { name, value } = e.target;

    this.setState({
      ratesObj: {
        ...ratesObj,
        [name]: value
      }
    });
  };

  filterSection = section => {
    const { policy } = this.props;
    const filtered = policy.goodsSections.filter(goodSection => {
      return goodSection.id === section;
    });

    return filtered.length > 0 ? filtered[0] : null;
  };

  addSectionRatesToList = e => {
    const { sectionRatesList, ratesObj } = this.state;

    const selectedSection = ratesObj.section;

    delete ratesObj.section; // Remove section key

    sectionRatesList.push({
      section: selectedSection,
      icc_a: ratesObj,
      icc_b: ratesObj,
      icc_c: ratesObj
    });

    this.setState({
      sectionRatesList
      // ratesObj: {} // Clears last inputted rates
    });
  };

  removeSectionRate = id => {
    const { sectionRatesList } = this.state;

    sectionRatesList.splice(id, 1);

    this.setState({ sectionRatesList });
  };

  onChangeFilter = e => {
    e.preventDefault();
    const { name, value } = e.target;

    this.setState({
      filter: {
        insurer: this.props.insurer,
        [name]: value
      }
    });
  };

  resetFilter = e => {
    const { insurer } = this.state;

    this.setState({
      filter: {
        insurer
      }
    });
  };

  buildRatesRow(multipleRows = true) {
    const { policy } = this.props;
    const { section, section_name, icc_a = {} } = this.state.activeRate;

    return (
      <tr>
        <td style={{ width: '200px' }}>
          {section ? (
            <div>{section_name || '-'}</div>
          ) : (
            <select
              className="form-control"
              name="section"
              required
              onChange={this.onChangeRate}
            >
              <option value="">-- Select a Section --</option>
              {policy.goodsSections.map((section, index) => {
                return (
                  <option key={index} value={section.id}>
                    {section.code}
                  </option>
                );
              })}
            </select>
          )}
        </td>
        <td>
          <label>Containerized (%)</label>
          <input
            type="number"
            name="sea_containerised_value"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={parseFloat(icc_a.sea_containerised_value) || ''}
          />

          <label>Non-Containerized (%)</label>
          <input
            type="number"
            name="sea_non_containerised_value"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={parseFloat(icc_a.sea_non_containerised_value) || ''}
          />

          <label>Excess</label>
          <textarea
            name="sea_excess"
            rows="4"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={icc_a.sea_excess || ''}
          />
        </td>
        <td>
          <label>Containerized (%)</label>
          <input
            type="number"
            name="road_containerised_value"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={parseFloat(icc_a.road_containerised_value) || ''}
          />

          <label>Non-Containerized (%)</label>
          <input
            type="number"
            name="road_non_containerised_value"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={parseFloat(icc_a.road_non_containerised_value) || ''}
          />

          <label>Excess</label>
          <textarea
            name="road_excess"
            rows="4"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={icc_a.road_excess || ''}
          />
        </td>
        <td>
          <label>Containerized (%)</label>
          <input
            type="number"
            name="rail_containerised_value"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={parseFloat(icc_a.rail_containerised_value) || ''}
          />

          <label>Non-Containerized (%)</label>
          <input
            type="number"
            name="rail_non_containerised_value"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={parseFloat(icc_a.rail_non_containerised_value) || ''}
          />

          <label>Excess</label>
          <textarea
            name="rail_excess"
            rows="4"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={icc_a.rail_excess || ''}
          />
        </td>
        <td style={{ minWidth: '100px', width: '22%' }}>
          <label>Air Value (%)</label>
          <input
            type="number"
            name="air_value"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={parseFloat(icc_a.air_value) || ''}
          />

          <label>Excess</label>
          <textarea
            name="air_excess"
            rows="4"
            className="form-control"
            onChange={this.onChangeRate}
            defaultValue={icc_a.rail_excess || ''}
          />
        </td>
        {multipleRows ? (
          <td>
            <span
              className="btn btn-xs btn-primary"
              onClick={this.addSectionRatesToList}
            >
              + Add
            </span>
          </td>
        ) : null}
      </tr>
    );
  }

  onSubmit = e => {
    e.preventDefault();
    const { insurer } = this.props.user.userInfo || {};
    const {
      filter,
      activeRate,
      ratesObj,
      sectionRatesList,
      ratesType
    } = this.state;
    const { intermediary_partnership, corporate_client } = filter;

    let customRatesObj = {
      id: activeRate.id,
      insurer,
      intermediary_partnership,
      corporate_client
    };

    if (ratesType === 'blanket') {
      customRatesObj = {
        ...customRatesObj,
        blanket: ratesObj
      };
    }

    if (ratesType === 'section') {
      customRatesObj = {
        ...customRatesObj,
        sections: sectionRatesList
      };
    }

    let handler = {};

    if (activeRate.hasOwnProperty('id')) {
      customRatesObj = {
        ...customRatesObj,
        icc_a: ratesObj,
        icc_b: ratesObj,
        icc_c: ratesObj
      };

      handler = this.props.updatePremiumRates(customRatesObj);
    } else {
      handler = this.props.saveCustomPremiumRates(customRatesObj);
    }

    handler.then(response => {
      this.props.fetchPremiumRates(this.state.filter);
    });
  };

  render() {
    const { filter, edit, ratesType, sectionRatesList } = this.state;
    const { brokers, covers, rates } = this.props;

    return (
      <div className="clearfix">
        {!edit ? (
          <div className="row">
            <div className="col-sm-4">
              <select
                name="intermediary_partnership"
                className="form-control"
                disabled={filter.hasOwnProperty('corporate_client')}
                onChange={this.onChangeFilter}
                value={filter.intermediary_partnership || ''}
              >
                <option value="">- Select Broker Partnership -</option>
                {brokers.partners.map((partner, index) => {
                  return (
                    <option key={index} value={partner.id}>
                      {partner.intermediary_name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-sm-4">
              <select
                name="corporate_client"
                className="form-control"
                disabled={filter.hasOwnProperty('intermediary_partnership')}
                onChange={this.onChangeFilter}
                value={filter.corporate_client || ''}
              >
                <option value="">- Select Open Cover Client -</option>
                {covers.openCovers.map((cover, index) => {
                  return (
                    <option key={index} value={cover.company}>
                      {cover.company_name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-sm-4">
              <button className="btn btn-default" onClick={this.resetFilter}>
                <i className="icon ion-loop" /> Reset
              </button>
            </div>
            <hr />

            <div className="col-sm-4">
              <select
                name="ratesType"
                className="form-control"
                onChange={this.setRatesType}
                required
              >
                <option value="">- Select Type of Rates -</option>
                <option value="blanket">Blanket</option>
                <option value="section">By Section</option>
              </select>
            </div>
            <hr />
          </div>
        ) : null}

        <div className="row form-horizontal">
          <div className="col-sm-12">
            {rates.saveCustomRatesLoading ? (
              <BlankState
                data={false}
                customMessage="Saving custom rates..."
                isDataLoading={rates.saveCustomRatesLoading}
              />
            ) : null}
            {rates.errorMessageSaveCustomRates &&
            !rates.saveCustomRatesLoading ? (
              <StatusMessages2
                type="error"
                message={rates.errorMessageSaveCustomRates}
              />
            ) : null}
            {rates.success && !rates.saveCustomRatesLoading ? (
              <StatusMessages2 type="success" message="Custom rates saved" />
            ) : null}
          </div>

          {ratesType === 'blanket' || edit ? (
            <div className="col-sm-12">
              <div className="clearfix table-legend">
                KEY: &nbsp;
                <span className="label label-success">
                  Containerised Value
                </span>{' '}
                &nbsp;
                <span className="label label-warning">
                  Non-containerised Value
                </span>{' '}
                &nbsp;
                <span className="label label-info">Value</span>
              </div>

              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th style={{ width: '200px' }}>Goods Section</th>
                    <th>Sea Rates</th>
                    <th>Road Rates</th>
                    <th>Rail Rates</th>
                    <th>Air Rates</th>
                  </tr>
                </thead>
                <tbody>{this.buildRatesRow(false)}</tbody>
              </table>
            </div>
          ) : null}

          {ratesType === 'section' ? (
            <div className="col-sm-12">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th style={{ width: '200px' }}>Goods Section</th>
                    <th>Sea Rates</th>
                    <th>Road Rates</th>
                    <th>Rail Rates</th>
                    <th>Air Rates</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {sectionRatesList.map((rates, index) => {
                    const { section, icc_a } = rates;

                    const selectedSection = this.filterSection(section);

                    return (
                      <tr key={index}>
                        <td>{selectedSection ? selectedSection.code : '-'}</td>
                        <td>
                          <div className="label label-success">
                            {icc_a.sea_containerised_value / 100}
                          </div>{' '}
                          <br />
                          <div className="label label-warning">
                            {icc_a.sea_non_containerised_value / 100}
                          </div>{' '}
                          <br />
                          <div className="label label-primary">
                            {icc_a.sea_excess / 100}
                          </div>
                        </td>
                        <td>
                          <div className="label label-success">
                            {icc_a.road_containerised_value / 100}
                          </div>{' '}
                          <br />
                          <div className="label label-warning">
                            {icc_a.road_non_containerised_value / 100}
                          </div>{' '}
                          <br />
                          <div className="label label-primary">
                            {icc_a.road_excess / 100}
                          </div>
                        </td>
                        <td>
                          <div className="label label-success">
                            {icc_a.rail_containerised_value / 100}
                          </div>{' '}
                          <br />
                          <div className="label label-warning">
                            {icc_a.rail_non_containerised_value / 100}
                          </div>{' '}
                          <br />
                          <div className="label label-primary">
                            {icc_a.rail_excess / 100}
                          </div>
                        </td>
                        <td>
                          <div className="label label-default">
                            {icc_a.air_value / 100}
                          </div>{' '}
                          <br />
                          <div className="label label-primary">
                            {icc_a.air_excess / 100}
                          </div>
                        </td>
                        <td>
                          <span
                            className="btn btn-xs btn-danger"
                            onClick={() => {
                              this.removeSectionRate(index);
                            }}
                          >
                            &#215; Remove
                          </span>
                        </td>
                      </tr>
                    );
                  })}

                  {this.buildRatesRow()}
                </tbody>
              </table>
            </div>
          ) : null}
        </div>

        <form className="form form-horizontal" onSubmit={this.onSubmit}>
          <div className="col-sm-12">
            <div className="form-group" style={{ marginTop: '1em' }}>
              {edit ? (
                <button type="submit" className="btn btn-warning">
                  <i className="icon ion-edit" />&nbsp; Update Rates
                </button>
              ) : (
                <button type="submit" className="btn btn-success">
                  <i className="icon ion-checkmark" />&nbsp; Save Rates
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  brokers: state.brokers,
  covers: state.covers,
  policy: state.policy,
  rates: state.rates
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { saveCustomPremiumRates, updatePremiumRates, fetchPremiumRates },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GoodsRatesForm);



// WEBPACK FOOTER //
// ./src/pages/dashboard/rates/GoodsRatesForm.jsx